

























import Vue from 'vue';
import { datetimeFormatToAmericanFormat, formatPrice } from '../../lib/utils';

export default Vue.extend({
    props: {
        userId: {
            required: true,
            type: Number,
        },
        userName: {
            required: true,
            type: String,
        },
        creditBalance: {
            required: true,
            type: Number,
        },
        creditData: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'Initiated By',
                    value: 'adminUser',
                    sortable: true,
                    width: 150,
                },
                {
                    text: 'Created',
                    value: 'createdWithTzUser',
                    sortable: true,
                    width: 150,
                },
                {
                    text: 'Type', value: 'type', sortable: true, width: 160,
                },
                { text: 'Value', value: 'valueUsd', width: 150 },
                { text: 'Comment', value: 'comment', width: 250 },
            ],
            data: [],
            balance: 0,
            loading: false,
            creditBalanceTitle: '',
            showBalance: false,
        };
    },
    watch: {
        creditBalance() {
            this.showBalance = this.creditBalance > 0;
        },
    },
    methods: {
        formatPrice,
        datetimeFormatToAmericanFormat,
    },
    async created() {
        this.showBalance = this.creditBalance > 0;
    },
});
